import * as Yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const palletLabelFileDataSchema = Yup.object().shape({
  sku: Yup.string().nullable().optional(),
  itemDescription: Yup.string().nullable().optional(),
  quantity: Yup.string().nullable().optional(),
  warehouseLocation: Yup.string().nullable().optional(),
  lot: Yup.string().nullable().optional(),
  expirationDate: Yup.string().nullable().optional(),
  expirationDateFormat: Yup.string().oneOf(['MM/DD/YYYY', 'MM/YYYY', 'YYYY']).nullable().optional(),
  poId: Yup.string().nullable().optional(),
  receivingTicketId: Yup.string().nullable().optional(),
  receiptDate: Yup.string().nullable().optional(),
  palletId: Yup.string().nullable().optional(),
  skuBarcode: Yup.string().nullable().optional(),
  palletBarcode: Yup.string().nullable().optional(),
  labelSize: Yup.string().oneOf(['compact', 'large']).nullable().optional(),
})

export type PalletLabelFileData = Yup.InferType<typeof palletLabelFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<PalletLabelFileData>

export const mockPalletLabelData: RequiredFileData = {
  sku: 'SKU-12345',
  itemDescription: 'Premium Coffee Beans - Medium Roast',
  quantity: '50 units',
  warehouseLocation: 'A-12-3',
  lot: 'LOT-2026-001',
  expirationDate: '06/30/2027',
  expirationDateFormat: 'MM/DD/YYYY',
  poId: 'PO-2026-0001',
  receivingTicketId: 'RT-2026-0001',
  receiptDate: '06/15/2026',
  palletId: 'PALLET-001',
  skuBarcode:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAyCAIAAACMIyF9AAAAbklEQVR4nO3PMQrAMAwEwSP///O5SBOwsNsN7FSyEYhNkrZt3yHJPuzP7/9h+bB23Rxvjeee/J8NDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA8MCXyNaCS3W+zgAAAAASUVORK5CYII=',
  palletBarcode:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAyCAIAAACMIyF9AAAAbklEQVR4nO3PMQrAMAwEwSP///O5SBOwsNsN7FSyEYhNkrZt3yHJPuzP7/9h+bB23Rxvjeee/J8NDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA8MCXyNaCS3W+zgAAAAASUVORK5CYII=',
  labelSize: 'compact',
}

export const palletLabelFileMappings: Record<keyof PalletLabelFileData, string | null> = {
  sku: '6d9b16ee-058a-40f2-adad-73cb640a0a3a',
  itemDescription: 'e08e2f2d-ea91-41b7-bb96-58307b212928',
  quantity: 'dadcc995-180f-4829-a0c8-137e09d20c8b',
  warehouseLocation: 'fa9e3a1b-703b-4120-a022-857fce63bf44',
  lot: '14c363eb-82b0-4701-b918-c877abb3ffd5',
  expirationDate: 'ea328a6a-57a4-42df-9a2d-949f08f3085a',
  expirationDateFormat: '0d7d9e33-a1c8-45d8-8c67-462dbcb979aa',
  poId: 'bd2275a5-6ec2-4490-a2f7-ca14cd894d1e',
  receivingTicketId: '14c95731-d48a-4612-8b15-0355e0545e13',
  receiptDate: 'c84fc36b-d2dd-4417-92dd-b2983e5ba41e',
  palletId: '06a4e3a8-eb43-4cf8-87ee-7a870864c510',
  skuBarcode: 'e6450c24-9817-4782-9942-bb61f3164235',
  palletBarcode: 'b4aba213-1cb2-40fd-a6cb-59b9ca3fbd7b',
  labelSize: '551bdf44-527c-449b-879c-a37e72f99ab8',
}
